export const defaultAccordionStates = {
  location: false,
  tasks: false,
  supporters: false,
  membership: false,
  contactable: false,
  engagement: false,
  mailing: false,
  roster: false,
  events: false,
  tags: false,
  groups: false,
  lists: false,
  age: false,
  branches: false,
  pathwaySteps: false,
  callingStatus: false,
};
